import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const billing = RepositoryFactory.get("billing");
const addOns = RepositoryFactory.get("addOns");

export default {
  createOrder({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await billing.createOrder(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getPlan({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await billing.getPlan({
          projectName: process.env.VUE_APP_COMMUNITY_NAME,
        });
        commit(
          "admin/SET_PLAN",
          { key: "selectedPlan", value: data.data },
          { root: true }
        );
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updatePlan({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await billing.updatePlan(payload);
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  myAddOns({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await addOns.myAddOns({
          projectName: process.env.VUE_APP_COMMUNITY_NAME,
        });
        commit(
          "admin/SET_MY_ADDONS",
          { key: "myAddOns", value: data.data },
          { root: true }
        );
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getModules({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await billing.getModules(payload);
        commit(
          "admin/USER_MODULES",
          { key: "userModules", value: data.data },
          { root: true }
        );
        // this.$store.commit("admin/USER_MODULES", {
        //   key: "userModules",
        //   value: data.data,
        // });
        resolve(data.data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  addBilling({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await billing.addBilling(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAllPlans({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await billing.getAllPlans(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getPaymentGateway({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await billing.getPaymentGateway(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
